import React, { useState } from 'react';
import {
  Button, Input, Card, Form, InputNumber, Row, Col,
} from 'antd';

function NewAnswerForm(props) {
  const { onAdd } = props;
  const [newAnswerText, setNewAnswerText] = useState('');
  const [newAnswerWeight, setNewAnswerWeight] = useState(0);

  const addNewAnswer = () => {
    onAdd(newAnswerText, newAnswerWeight);
    setNewAnswerText('');
    setNewAnswerWeight(0);
  };

  return (
    <Card
      title="Добавить ответ"
    >
      <Form>
        <Form.Item>
          <Input.Group size="large">
            <Row gutter={8}>
              <Col span={12}>
                <Input
                  placeholder="Текст ответа"
                  size="large"
                  value={newAnswerText}
                  onChange={(e) => { setNewAnswerText(e.target.value); }}
                />
              </Col>
              <Col span={12}>
                <InputNumber
                  size="large"
                  min={0}
                  max={10}
                  value={newAnswerWeight}
                  onChange={(e) => {
                    setNewAnswerWeight(e);
                  }}
                />
              </Col>
            </Row>
          </Input.Group>
        </Form.Item>
        <Button
          type="primary"
          size="large"
          onClick={addNewAnswer}
          disabled={!newAnswerText.length > 0}
        >
          Добавить ответ
        </Button>
      </Form>
    </Card>
  );
}

export default NewAnswerForm;
